import React, { Component, createRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import SwalServices from '../../services/swalServices/SwalServices';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { Navigate } from "react-router-dom";
import { Calendar } from 'primereact/calendar';
import { APIURL, DownloadCV, PreviewCV } from '../../services/axiosServices/ApiEndPoints';
import { getAuthProps } from '../../utils/AuthenticationLibrary';
import { ProgressSpinner } from 'primereact/progressspinner';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default class CVList extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.dt = createRef();
        this.state = {
            cvList: [],
            downloadingIds: [],
            route: null,
            isLoading: false,
            dateRange: null,
            totalRecords: 0,
            filterDetails: {
                start: 0,
                length: 50,
                search: '',
                roleId: '',
                sortField: '',
                sortOrder: 'asc',
                startDate: '',
                endDate: '',
            }
        };
        this.exportCSV = this.exportCSV.bind(this);
        this.exportPdf = this.exportPdf.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
        this.saveAsExcelFile = this.saveAsExcelFile.bind(this);
    }


    componentDidMount() {
        this.getCVList();
    }

    getCVList = () => {
        let filterDetails = this.state.filterDetails;
        this.setState({ isLoading: true });
        let request = [
            filterDetails.start,
            filterDetails.length,
            filterDetails.search,
            filterDetails.roleId,
            filterDetails.sortField,
            filterDetails.sortOrder,
            filterDetails.startDate && Number(moment(filterDetails.startDate).format('YYYYMMDD')),
            filterDetails.endDate && Number(moment(filterDetails.endDate).format('YYYYMMDD'))
        ];
        this.adminServices.getCVList(request).then((response) => {
            if (response && response.data && response !== null) {
                let res = response.data;
                res.map((x, index) => {
                    x.srNo = index + 1
                })
                this.setState({ cvList: res, totalRecords: response.totalRecords });
                this.setState({ isLoading: false });
            }
        });
    };

    actionBodyTemplate = (rowData) => {
        const isDownloading = this.state.downloadingIds.includes(rowData.id);
        return (
            <div className="flex gap-2 justify-center items-center">
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handlePreviewPDF(rowData)}
                    tooltip="Preview PDF"
                    tooltipOptions={{ position: 'top' }}
                />
                {/* <Button
                    icon="pi pi-download"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handleDownloadPDF(rowData)}
                    tooltip="Download PDF"
                    tooltipOptions={{ position: 'top' }}
                /> */}
                {
                    isDownloading ? (
                        <div style={{ width: '2rem' }}>
                            <ProgressSpinner style={{ width: '60%', height: '60%' }} strokeWidth="4" />
                        </div>
                    ) : (
                        <Button
                            icon="pi pi-download"
                            className="p-button-rounded p-button-text p-button-sm"
                            style={{ width: '2rem', height: '2rem', padding: 0 }}
                            onClick={() => this.handleDownloadPDF(rowData)}
                            tooltip="Download PDF"
                            tooltipOptions={{ position: 'top' }}
                        />
                    )
                }
            </div>
        );
    };

    // handlePreviewPDF = async (rowData) => {
    //     const pdfUrl = rowData.cvpath;
    //     const loginUser = getAuthProps();
    //     const token = loginUser.token;

    //     const url = `${APIURL}${PreviewCV}${pdfUrl}`;

    //     try {
    //         const response = await fetch(url, {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`
    //             }
    //         });

    //         if (response.ok === true) {
    //             const blob = await response.blob();
    //             const fileURL = URL.createObjectURL(blob);
    //             window.open(fileURL, '_blank');
    //         } else {
    //             this.swalServices.Error('File not found')
    //         }
    //     } catch (err) {
    //         console.error('Error opening PDF', err);
    //     }
    // };

    handlePreviewPDF = (rowData) => {
        const filePath = rowData.cvpath;
        const ext = filePath.split('.').pop().toLowerCase();

        const isGoogleDocsCompatible = ['doc', 'docx', 'xls', 'xlsx'].includes(ext);
        // const publicPreviewUrl = `https://testapi.arbourhealthcaregroup.co.uk/api/v1/public-preview${filePath}`;
        const publicPreviewUrl = `https://testapi.arbourhealthcaregroup.co.uk${filePath}`;

        if (isGoogleDocsCompatible) {
            const viewerUrl = `https://docs.google.com/viewerng/viewer?url=${encodeURIComponent(publicPreviewUrl)}`;
            window.open(viewerUrl, '_blank');
        } else {
            // Existing logic for PDFs
            const loginUser = getAuthProps();
            const token = loginUser.token;
            const secureUrl = `${APIURL}${PreviewCV}${filePath}`;

            fetch(secureUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }).then(async response => {
                if (response.ok) {
                    const blob = await response.blob();
                    const blobUrl = URL.createObjectURL(blob);
                    window.open(blobUrl, '_blank');
                } else {
                    this.swalServices.Error('File not found');
                }
            }).catch(err => {
                console.error('Error opening file', err);
            });
        }
    };


    handleDownloadPDF = async (rowData) => {
        const id = rowData.id;
        const loginUser = getAuthProps();
        const token = loginUser.token;
        const url = APIURL + DownloadCV + rowData.cvpath;

        this.setState(prevState => ({
            downloadingIds: [...prevState.downloadingIds, id]
        }));

        try {
            const response = await fetch(url, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (response.ok === true) {
                const blob = await response.blob();
                const downloadUrl = URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = downloadUrl;

                let filename = rowData.cvpath.split('/').pop();
                link.download = filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                URL.revokeObjectURL(downloadUrl);
            } else {
                this.swalServices.Error('File not found')
            }
        } catch (err) {
            console.error('Download failed', err);
        } finally {
            // Remove from downloadingIds
            this.setState(prevState => ({
                downloadingIds: prevState.downloadingIds.filter(id => id !== id)
            }));
        }

    };

    handleSearch = (value) => {
        let details = this.state.filterDetails
        details.search = value;
        this.setState({ filterDetails: details }, () => {
            this.getCVList();

        });
    }

    handleChangeDateRange = (value) => {
        let details = this.state.filterDetails

        if (value[0]) {
            details.startDate = value[0];
            details.startDate = details.startDate.setHours(0, 0, 0, 0);
        }

        if (value[1]) {
            details.endDate = value[1];
            details.endDate = details.endDate.setHours(23, 59, 59, 999);
        }
        this.setState({ filterDetails: details, dateRange: value }, () => {
            if (this.state.filterDetails.startDate && this.state.filterDetails.endDate) {
                this.getCVList();
            }

        });
    }

    resetFilter = () => {
        let details = this.state.filterDetails
        details.search = '';
        details.startDate = '';
        details.endDate = '';
        this.setState({ filterDetails: details, dateRange: null }, () => {
            this.getCVList()
        });
    }

    onPageChange = (event) => {
        let details = this.state.filterDetails
        details.start = event.first;
        details.length = event.rows;
        this.setState({ filterDetails: details }, () => {
            this.getCVList();
        })
    };

    onSortChange = (event) => {
        const filterDetails = { ...this.state.filterDetails };
        filterDetails.sortField = event.sortField;
        filterDetails.sortOrder = event.sortOrder === 1 ? 'asc' : 'desc';
        this.setState({ filterDetails }, () => {
            this.getCVList();
        });
    };

    // exportCSV(selectionOnly) {
    //     if (this.dt.current) {
    //         this.dt.current.exportCSV({ selectionOnly });
    //     }
    // }

    exportCSV(selectionOnly) {
        if (this.dt.current) {
            const data = selectionOnly ? this.dt.current.props.value.filter(row => this.dt.current.isSelected(row)) : this.dt.current.props.value;

            let csv = '';
            let columns = this.dt.current.props.children;

            columns = columns.filter(col => col.props.header !== 'Actions');
            csv += columns.map(col => col.props.header).join(',') + '\n';

            data.forEach(rowData => {
                const row = columns.map(col => {
                    const field = col.props.field;
                    return '"' + (rowData[field] !== undefined ? rowData[field] : '') + '"';
                });
                csv += row.join(',') + '\n';
            });

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const filename = 'CV List.csv';

            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                const url = URL.createObjectURL(blob);
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    getExportColumns() {
        return this.state.cvList.map((col) => ({ title: 'ABC', dataKey: 'XYZ' }));
    }

    exportPdf() {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                const exportColumns = this.getExportColumns();
                doc.autoTable(exportColumns, this.state.cvList);
                doc.save('CV List.pdf');
            });
        });
    }

    saveAsExcelFile(buffer, fileName) {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], { type: EXCEL_TYPE });

                module.default.saveAs(data, "CV List" + EXCEL_EXTENSION);
            }
        });
    }

    exportExcel() {
        import('xlsx').then((xlsx) => {
            const modifiedData = this.state.cvList.map(({ jobid, id, jobtypeids, ...rest }) => {
                const { srNo, ...others } = rest;
                return { srNo, ...others };
            });
            const worksheet = xlsx.utils.json_to_sheet(modifiedData);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });

            this.saveAsExcelFile(excelBuffer, 'cvList');
        });
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }

        const pageSizes = [5, 10, 20, 50, 100];
        let rowsPerPageOptions = pageSizes.filter(size => size < this.state.totalRecords);

        if (!rowsPerPageOptions.includes(this.state.totalRecords)) {
            rowsPerPageOptions.push(this.state.totalRecords);
        }

        const paginatorRight = (
            <div className="flex gap-2">
                <Button label="Export CSV" icon="pi pi-file" className="export-btn" onClick={() => this.exportCSV(false)} />
                {/* <Button label="Export PDF" icon="pi pi-file-pdf" className="export-btn" onClick={this.exportPdf} /> */}
                <Button label="Export Excel" icon="pi pi-file-excel" className="export-btn" onClick={this.exportExcel} />
            </div>
        );

        return (
            <div className='cv-lists'
                style={{ height: "calc((100dvh / 0.85) - 60.8px)" }}
            >
                <div className='cv-lists-inner h-full p-[30px]'>
                    <div className='title flex items-center justify-between mb-[10px]'>
                        <h1 className='text-[22px] m-0 font-semibold text-[#004AAD]' style={{ lineHeight: "30px" }}>
                            CV list
                        </h1>
                    </div>

                    <div className="cv-table p-5 bg-white rounded-[16px]" style={{ border: "1px solid #DFDFDF" }}>
                        <div className='table-inner grid grid-cols-3 gap-5 items-end'>
                            <div className="input-grp !mb-0">
                                <label>
                                    Search
                                </label>
                                <InputText
                                    type="search"
                                    value={this.state.filterDetails.search}
                                    onChange={(e) => this.handleSearch(e.target.value)}
                                    placeholder="Search across all columns..."
                                    style={{ height: "42px" }}
                                />
                            </div>
                            <div className="input-grp !mb-0">
                                <label>
                                    Filter by Date Range
                                </label>
                                <Calendar
                                    value={this.state.dateRange}
                                    onChange={(e) => this.handleChangeDateRange(e.value)}
                                    selectionMode="range"
                                    placeholder="Select date range"
                                    dateFormat="dd-mm-yy"
                                    readOnlyInput
                                    numberOfMonths={2}
                                    maxDate={new Date()}
                                    style={{ height: "42px" }}
                                />
                            </div>
                            <Button
                                label="Reset filters"
                                className='w-fit h-fit'
                                onClick={() => this.resetFilter()}
                                style={{ fontWeight: "400", lineHeight: "1" }}
                            />
                        </div>
                        <div className='sub-table rounded-xl shadow-sm overflow-hidden border border-gray-200 bg-white mt-[30px]'>
                            <DataTable
                                value={this.state.cvList}
                                paginator
                                lazy
                                first={this.state.filterDetails.start}
                                rows={(this.state.totalRecords > this.state.filterDetails.length) ? this.state.filterDetails.length : this.state.totalRecords}
                                totalRecords={this.state.totalRecords}
                                onPage={(e) => this.onPageChange(e)}
                                rowsPerPageOptions={rowsPerPageOptions}
                                responsiveLayout="scroll"
                                scrollable
                                scrollHeight="calc((100dvh / 0.85) - 360px)"
                                className="min-w-full"
                                filterFunction={this.filterByDateRange}
                                filterElement={this.dateRangeFilterTemplate}
                                emptyMessage="No data found"
                                loading={this.state.isLoading}
                                loadingIcon={
                                    <div className="flex justify-center items-center w-full py-4">
                                        <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                                    </div>
                                }
                                onSort={(e) => this.onSortChange(e)}
                                sortField={this.state.filterDetails.sortField}
                                sortOrder={this.state.filterDetails.sortOrder === 'asc' ? 1 : -1}
                                paginatorRight={paginatorRight}
                                ref={this.dt}
                            >
                                <Column
                                    field="srNo"
                                    body={(rowData, options) => options.rowIndex + 1}
                                    header="Sr No" filterPlaceholder="Search by ID" headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="firstname" header="First Name" sortable filterPlaceholder="Search by first name" headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="lastname" header="Last Name" sortable filterPlaceholder="Search by last name" headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="email" header="Email" sortable filterPlaceholder="Search by email" headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="jobname" header="Job Name" sortable filterPlaceholder="Search by job" headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="locationname" header="Location" sortable filterPlaceholder="Search by location" headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="mobile" header="Mobile" sortable filterPlaceholder="Search by location" headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="createddate" header="Submitted Date" sortable filterPlaceholder="Search by createddate" headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column
                                    header="Actions"
                                    body={this.actionBodyTemplate}
                                    style={{ textAlign: 'center', width: '10rem' }}
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                />
                            </DataTable>


                        </div>
                    </div>

                </div>
            </div >
        );
    }
}
